(() => {
  const hiddenClass = "is-hidden";
  const activeClass = "is-active";

  function setActiveButton(buttons, activeButton) {
    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle(activeClass, isActive);
      button.setAttribute("aria-pressed", String(isActive));
    });
  }

  function applyFilter(section, filterValue) {
    const items = section.querySelectorAll("[data-filter-item]");

    items.forEach((item) => {
      const tagString = item.getAttribute("data-tags") || "";
      const tags = tagString.split(" ").filter(Boolean);
      const shouldShow = filterValue === "all" || tags.includes(filterValue);

      if (shouldShow) {
        item.hidden = false;
        requestAnimationFrame(() => {
          item.classList.remove(hiddenClass);
          item.classList.add("is-visible");
        });
      } else {
        item.classList.remove("is-visible");
        item.classList.add(hiddenClass);
        window.setTimeout(() => {
          if (item.classList.contains(hiddenClass)) {
            item.hidden = true;
          }
        }, 250);
      }
    });
  }

  function initSection(section) {
    const buttons = section.querySelectorAll("[data-filter-button]");
    if (!buttons.length) return;

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const filterValue = button.getAttribute("data-filter") || "all";
        setActiveButton(buttons, button);
        applyFilter(section, filterValue);
      });
    });
  }

  function init() {
    document
      .querySelectorAll('[data-section-type="main-blog-looom"]')
      .forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
